export const replaceUrl = (url, nameSlug, value) => {
  return url.replace(`{${nameSlug}}`, value);
};
